import React, { memo } from 'react'
import { InlineDisplayWrapper } from 'apps/fleet-planner/components/load-details/InlineDisplayWrapper'
import * as Types from 'apps/fleet-planner/types'
import { DISPLAY } from 'constants/display'

interface ITrailerDisplayProps extends Types.IInlineDisplayProps<Types.ITrailer> {}

export const TrailerInlineDisplay = memo<ITrailerDisplayProps>(({ value: valueProp }) => {
  const { id: idProp, trailerNumber: trailerNumberProp } = valueProp || {}
  const trailerNumber = idProp ? trailerNumberProp : undefined

  return <InlineDisplayWrapper label='Trailer' value={trailerNumber ?? DISPLAY.empty} />
})
